import React from "react";
import IUser from "../types/user.type";
import AuthService from "../services/auth.service";
import PayService from "../services/pay.service";
import IPayslip from "../types/payslip.type";
import IDeduction from "../types/deduction.type";
import IPayrollHistory from "../types/payrollhistory.type";
import moment from "moment";
import {toast, ToastContainer} from "react-toastify";
import IOvertime from "../types/overtime.type";
import ILeave from "../types/leave.type";
import IPayroll from "../types/payroll.type";
import LeaveService from "../services/leave.service";
import OvertimeService from "../services/overtime.service";
import { getDateLocale, t, subscribeLanguage } from "../i18n";

type Props = {
    selectMonth: Date,
    queryUser: IUser
}

type State = {
    isModerator: boolean,
    isAdmin: boolean,
    currentUser: IUser,
    queryUser: IUser,
    selectMonth: Date,
    payslip: IPayslip,
    showMoney: boolean,
    payrollHistories: IPayrollHistory[],
    newOTRequest: IOvertime,
    OTRequests: IOvertime[]
}

export default class UserPayslip extends React.Component<Props, State> {
    private unsubscribeLang?: () => void;

    constructor(props: any) {
        super(props);
        this.state = {
            isModerator: false,
            isAdmin: false,
            currentUser: {} as IUser,
            selectMonth: this.props.selectMonth,
            queryUser: this.props.queryUser,
            payslip: {} as IPayslip,
            payrollHistories: [] as IPayrollHistory[],
            showMoney: false,
            OTRequests: [] as IOvertime[],
            newOTRequest: {
                date: moment().format("YYYY-MM-DD"),
                ot_hour: 1
            } as IOvertime
        };

        this.handleChangeShowSalary = this.handleChangeShowSalary.bind(this);
        this.handleChangeReason = this.handleChangeReason.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleChangeOTTime = this.handleChangeOTTime.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount = () => {
        const user = AuthService.getCurrentUser();
        if (user) {
            this.setState({
                currentUser: user,
                isModerator: user.roles?.includes("ROLE_MODERATOR"),
                isAdmin: user.roles?.includes("ROLE_ADMIN"),
            });
        }
        this.unsubscribeLang = subscribeLanguage(() => this.forceUpdate());
    };

    componentWillUnmount() {
        this.unsubscribeLang?.();
    }

    componentDidUpdate = () => {
        if (this.state.selectMonth != this.props.selectMonth || this.state.queryUser != this.props.queryUser) {
            this.setState({
                selectMonth: this.props.selectMonth,
                queryUser: this.props.queryUser,
                payslip: {} as IPayslip,
                payrollHistories: [] as IPayrollHistory[],
            });
            this.updateData();
        }
    };

    updateData() {
        if (this.props.queryUser?.email == null)
            return;
        PayService.getPayslip(this.props.queryUser?.email!, this.props.selectMonth.getMonth() + 1, this.props.selectMonth.getFullYear()).then(
            (a: IPayslip) => {
                this.setState({
                    payslip: a
                });
            }
        );
        PayService.getPayrollHistory(this.props.queryUser?.email!).then(
            (a: IPayrollHistory[]) => {
                this.setState({
                    payrollHistories: a
                });
            }
        );
        OvertimeService.getOvertimeRequests(this.props.queryUser?.email!, this.props.selectMonth.getMonth() + 1, this.props.selectMonth.getFullYear()).then(
            (ot: IOvertime[]) => {
                this.setState({
                    OTRequests: ot
                });
            }
        )
    };

    CreateLink = (isAdmin: boolean, email: string, picture: string) => {
        if (isAdmin) {
            return (<a href={"/user?email=" + email}><img src={picture} alt="user" className="img-circle"
                                                          width="150"/></a>);
        } else {
            return (<img src={picture} alt="user" className="img-circle" width="150"/>);
        }
    };

    handleChangeShowSalary(event: React.ChangeEvent<HTMLInputElement>) {
        const showMoney = !this.state.showMoney;
        this.setState({
            showMoney: showMoney
        });
    }

    CurrencyFormat = (num: number) => {
        return new Intl.NumberFormat('vi-VN', {style: 'currency', currency: 'VND'}).format(num);
    };

    CurrencyFormatShort = (value: number) => {
        const abs = Math.abs(value);
        if (abs >= 1_000_000_000) {
            return (value / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
        }
        if (abs >= 1_000_000) {
            return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (abs >= 1_000) {
            return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return value.toString();
    }

    ShowAllOvertimeBonuses = () => {
        const {payslip, showMoney} = this.state;
        if (payslip?.overtimes == null)
            return <></>;
        return payslip?.overtimes!.map((ot, index) => (
            <div className="d-flex m-l-20" key={index}>
                <div className="align-self-center"><span
                    className="label label-purple label-rounded text-bold">OT</span> {moment(ot.date).format("ddd, MMM DD")} - {ot.ot_hour} hours
                </div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(ot.salary!)}</h6>
                </div>
            </div>
        ))
    };

    ShowAllOthersBonuses = () => {
        const {payslip, showMoney} = this.state;
        if (payslip?.bonuses == null)
            return <></>;
        return payslip?.bonuses!.map((deduction, index) => (
            <div className="d-flex m-l-20" key={index}>
                <div className="align-self-center"><i
                    className="fa fa-plus-circle text-bold-green"></i> {deduction.reason}</div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(deduction.money!)}</h6>
                </div>
            </div>
        ))
    };

    ShowAllOthersDeductions = () => {
        const {payslip, showMoney} = this.state;
        if (payslip?.deductions == null)
            return <></>;
        return payslip?.deductions!.map((deduction, index) => (
            <div className="d-flex m-l-20" key={index}>
                <div className="align-self-center"><i
                    className="fa fa-minus-circle text-warning"></i> {deduction.reason}</div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(deduction.money!)}</h6>
                </div>
            </div>
        ))
    };

    ShowAllAmercementReason = () => {
        const {payslip, showMoney} = this.state;
        if (payslip?.amercement_reasons == null)
            return <></>;
        return payslip?.amercement_reasons!.map((amercement, index) => (
            <div className="d-flex m-l-20" key={index}>
                <div
                    className="align-self-center">- {moment(amercement.date).format("ddd, MMM DD")}: {amercement.reason}</div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{amercement.count!}</h6>
                </div>
            </div>
        ))
    };

    ShowPersonalTaxInfo = () => {
        const {payslip, showMoney} = this.state;
        if (payslip?.personal_tax_breakdown == null)
            return <></>;
        return <>
            <div className="d-flex m-l-20">
                <div className="align-self-center">- {t('tax.taxableIncome')}</div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(Number(payslip?.personal_gross_income!))}</h6>
                </div>
            </div>
            <div className="d-flex m-l-20">
                <div className="align-self-center">- {t('tax.selfDeduction')}</div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(payslip.personal_tax_self_allowance!)}</h6>
                </div>
            </div>
            <div className="d-flex m-l-20">
                <div className="align-self-center">- {t('tax.dependentDeduction')} {payslip.dependent}</div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(payslip.personal_tax_dependent_allowance!)}</h6>
                </div>
            </div>
            <div className="d-flex m-l-20">
                <div className="align-self-center">- {t('tax.netTaxableIncome')}</div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(payslip.personal_taxable_income!)}</h6>
                </div>
            </div>
        </>;
    };

    ShowPersonalTaxBreakdown = () => {
        const {payslip, showMoney} = this.state;
        if (payslip?.personal_tax_breakdown == null)
            return <></>;
        return payslip?.personal_tax_breakdown!.map((breakdown, index) => (
            <div className="d-flex m-l-20" key={index}>
                <div className="align-self-center">
                    <span className="label label-success label-rounded text-bold">TAX</span> {t('tax.upTo')} {this.CurrencyFormatShort(breakdown.to!)}: {!showMoney ? "******" : this.CurrencyFormat(breakdown.taxable_amount!)} {"*"} {Number(breakdown.rate!) * 100}%
                </div>
                <div className="ml-auto align-self-center">
                    <h6 className="text-muted">{!showMoney ? "******" : this.CurrencyFormat(breakdown.tax!)}</h6>
                </div>
            </div>
        ))
    };

    capitalize = (s: string) => {
        return s && s[0].toUpperCase() + s.slice(1);
    };

    GetInstallmentMonths(att: IDeduction) {
        const months = (Number(att.year_end!) - this.props.selectMonth.getFullYear()) * 12 + Number(att.month_end!) - this.props.selectMonth.getMonth();
        return Math.max(Math.min(months, Number(att.total_months!)), 0);
    };

    GetInstallmentThisMonth() {
        const {payslip} = this.state;
        if (payslip?.installments == null)
            return 0;
        let total = 0;
        payslip?.installments.map((deduction) => (
            total += (new Date(deduction.year!, deduction.month! - 1, 1) <= this.props.selectMonth && this.props.selectMonth < new Date(deduction.year_end!, deduction.month_end!, 1)) ? Number(deduction.money! / deduction.total_months! * (1 + deduction.installment_rate! / 100)) : 0
        ));
        return total;
    };

    ShowInstallmentTable() {
        const {payslip, showMoney} = this.state;
        if (payslip?.installments != null && payslip?.installments.length > 0) {
            return payslip?.installments.map((att) => (
                <tr key={att.id}>
                    <td>{att.reason}</td>
                    <td>{!showMoney ? "******" : this.CurrencyFormat(Number(att.money!))}</td>
                    <td>{!showMoney ? "******" : this.CurrencyFormat(Number(att.money! / att.total_months! * (1 + att.installment_rate! / 100) * this.GetInstallmentMonths(att)))}</td>
                    <td>{att.month}/{att.year}</td>
                    <td>{att.month_end}/{att.year_end}</td>
                </tr>
            ))
        }
    };

    ShowPayrollHistoryHeader() {
        return (
            <tr>
                <th className="footable-visible footable-sortable"> {t('payrollHistory.date')}</th>
                <th className="footable-visible footable-sortable"> {t('payrollHistory.salary')}</th>
                <th className="footable-visible footable-sortable"> {t('payrollHistory.bonus')}</th>
                <th className="footable-visible footable-sortable"> {t('payrollHistory.employeeType')}</th>
                <th className="footable-visible footable-sortable"> {t('payrollHistory.annualLeaves')}</th>
                <th className="footable-visible footable-sortable"> {t('payrollHistory.description')}</th>
                <th className="footable-visible footable-sortable"> {t('payrollHistory.applyDate')}</th>
            </tr>
        );
    }

    ShowPayrollHistoryTable() {
        const {payrollHistories, showMoney} = this.state;
        if (payrollHistories != null) {
            return payrollHistories.reverse().map((att) => (
                <tr key={att.id}>
                    <td>{(new Date(att.offer_date!)).toLocaleDateString(getDateLocale())}</td>
                    <td>{!showMoney ? "******" : this.CurrencyFormat(att.salary!)}</td>
                    <td>{!showMoney ? "******" : this.CurrencyFormat(att.bonus!)}</td>
                    <td>{att.employee_type!.toUpperCase()}</td>
                    <td>{att.annual_leaves!}</td>
                    <td>{att.description!}</td>
                    <td>{(!att.apply_date || att.apply_date.length === 0) ? (att.apply_month + '/' + att.apply_year) : (new Date(att.apply_date!)).toLocaleDateString(getDateLocale())}</td>
                </tr>
            ))
        }
    };

    ShowToast = (message: string) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    UpdateOTRequest = (leave: IOvertime) => {
        this.setState({
            newOTRequest: leave
        });
    };

    ShowOTTag = (approve: number) => {
        if (approve == 0) {
            return (<span className="pull-right label label-danger label-rounded">{t('overtime.declined')}</span>);
        } else if (approve == 1) {
            return (<span className="pull-right label label-success label-rounded">{t('overtime.approved')}</span>);
        } else {
            return (<span className="pull-right label label-warning label-rounded">{t('overtime.awaiting')}</span>);
        }
    };

    ShowMultiplierTag = (multiplier: number) => {
        if (multiplier == 2) {
            return (<span className="label label-purple label-rounded text-bold">200%</span>);
        } else if (multiplier == 3) {
            return (<span className="label label-danger label-rounded text-bold">300%</span>);
        }
        return (<span className="label label-success label-rounded text-bold">150%</span>);
    }

    ShowOTRequests = () => {
        const {OTRequests} = this.state;
        if (OTRequests != null) {
            return OTRequests.map((att, i) => (
                <div style={{cursor: "pointer"}} data-toggle="modal" data-target="#update-request-leave-modal"
                     onClick={() => this.UpdateOTRequest(att)} key={i}>
                    <div className="card-body p-0">
                        {this.ShowOTTag(att.approve!)}
                        <h5 className="card-title text-bold">{moment(att.date).format("ddd, MMM DD")}</h5>
                        <small className="pull-right">{t('overtime.showDetail')}</small>
                        <h6>{this.ShowMultiplierTag(att.multiplier!)} {att.ot_hour!} hours</h6>
                    </div>
                    <hr/>
                </div>
            ))
        }
    };

    handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        const {currentUser, newOTRequest} = this.state;
        if (newOTRequest.date == null) {
            this.ShowToast(t('validation.dateEmpty'));
            return;
        }
        if (newOTRequest.reason == null) {
            this.ShowToast(t('validation.reasonEmpty'));
            return;
        }
        OvertimeService.request(currentUser.id!, currentUser.email!, newOTRequest.date!, newOTRequest.month!, newOTRequest.year!, newOTRequest.ot_hour!, newOTRequest.reason!).then(
            (result) => {
                if (result['code'] == 0) {
                    window.location.reload();
                } else {
                }
            });
    };

    handleUpdate: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        const {currentUser, newOTRequest} = this.state;
        if (newOTRequest.date == null) {
            this.ShowToast(t('validation.dateEmpty'));
            return;
        }
        if (newOTRequest.reason == null) {
            this.ShowToast(t('validation.reasonEmpty'));
            return;
        }
        OvertimeService.update(currentUser.email!, newOTRequest.id!, newOTRequest.date!, newOTRequest.month!, newOTRequest.year!, newOTRequest.ot_hour!, newOTRequest.reason!).then(
            (result) => {
                if (result['code'] == 0) {
                    // window.location.reload();
                } else {
                }
                console.log(result);
            });
    };

    handleChangeReason(event: React.ChangeEvent<HTMLTextAreaElement>) {
        let newOTRequest = this.state.newOTRequest;
        newOTRequest.reason = event.target.value;
        this.setState({
            newOTRequest: newOTRequest
        });
    }

    handleChangeDate(event: React.ChangeEvent<HTMLInputElement>) {
        let newOTRequest = this.state.newOTRequest;
        newOTRequest.date = event.target.value;
        this.setState({
            newOTRequest: newOTRequest
        });
    }

    handleChangeOTTime(event: React.ChangeEvent<HTMLSelectElement>) {
        let newOTRequest = this.state.newOTRequest;
        newOTRequest.ot_hour = Number(event.target.value);
        this.setState({
            newOTRequest: newOTRequest
        });
    }

    render() {
        const {payslip, showMoney, isAdmin, currentUser, newOTRequest} = this.state;
        return (
            <>
                <>
                    <div className="col-lg-4 col-xlg-4 col-md-4">
                        <div className="card">
                            <div className="m-t-30 text-center">
                                {this.CreateLink(isAdmin, payslip?.user?.email!, payslip?.user?.picture!)}
                                <h4 className="card-title m-t-10">{payslip?.user?.name!}</h4>
                                <h5 className="card-subtitle">{payslip?.user?.title!} {payslip?.employee_type != null && payslip?.employee_type != 'official' ? (' - ' + this.capitalize(payslip?.employee_type!)) : ''}</h5>
                                <input name="show_money" type="checkbox" id="show_money"
                                       onChange={this.handleChangeShowSalary}
                                       className="filled-in chk-col-cyan"/>
                                <label htmlFor="show_money">{t('payslip.showSalary')}</label>
                            </div>
                            <div><hr/></div>
                            <div className="p-20">
                                <div className="d-flex">
                                    <div className="align-self-center text-bold">{t('payslip.amercement')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4 className="text-bold-orange">{this.CurrencyFormat(payslip?.amercement!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.checkInLate')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{payslip?.check_in_late!} min</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="align-self-center">{t('payslip.requestDeclined')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{Number(payslip?.request_decline_amercement!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="align-self-center">{t('payslip.otherAmercement')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{Number(payslip?.forgot_check_in_out!) + Number(payslip?.check_out_early_amercement!) + Number(payslip?.absent_day!)}</h4>
                                    </div>
                                </div>
                                {this.ShowAllAmercementReason()}
                            </div>
                            <div><hr/></div>
                            <div className="p-20">
                                <div className="d-flex">
                                    <div>{t('payslip.workingDayPlan')}</div>
                                    <div className="ml-auto align-self-center"><h4>{payslip?.total_working_days!}</h4></div>
                                </div>
                                <div className="d-flex">
                                    <div className="align-self-center">{t('payslip.paidWorkingDay')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{Number(payslip?.paid_working_days!) + Number(payslip?.paid_leave!) + Number(payslip?.annual_leave!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex m-l-20">
                                    <div className="align-self-center">{t('payslip.actualWorkingDay')}</div>
                                    <div className="ml-auto align-self-center"><h6 className="text-muted">{payslip?.paid_working_days!}</h6></div>
                                </div>
                                <div className="d-flex m-l-20">
                                    <div className="align-self-center">{t('payslip.paidLeaveDay')}</div>
                                    <div className="ml-auto align-self-center"><h6 className="text-muted">{payslip?.paid_leave!}</h6></div>
                                </div>
                                <div className="d-flex m-l-20">
                                    <div className="align-self-center">{t('payslip.unpaidLeaveDay')}</div>
                                    <div className="ml-auto align-self-center"><h6 className="text-muted">{payslip?.leave_day!}</h6></div>
                                </div>
                                {payslip.employee_type == 'official' && <div className="d-flex m-l-20">
                                    <div className="align-self-center">{t('payslip.annualLeaveDay')}</div>
                                    <div className="ml-auto align-self-center"><h6 className="text-muted">{payslip?.annual_leave!}</h6></div>
                                </div>}
                                {payslip.employee_type == 'official' && <div className="d-flex">
                                    <div>{t('payslip.remainAnnualLeaves')}</div>
                                    <div className="ml-auto align-self-center"><h4>{payslip?.annual_leave_remain!}</h4></div>
                                </div>}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-xlg-4 col-md-4">
                        <div className="card">
                            <div className="p-20">
                                <div className="d-flex">
                                    <div className="align-self-center text-bold">{t('payslip.earnings')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4 className="text-bold-green">{!showMoney ? "******" : this.CurrencyFormat(payslip?.earnings!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.baseSalary')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.salary!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="align-self-center">{t('payslip.bonus')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(Number(payslip?.bonus!) + Number(payslip?.overtime_paid!))}</h4>
                                    </div>
                                </div>
                                {this.ShowAllOthersBonuses()}
                                {this.ShowAllOvertimeBonuses()}
                                <div className="d-flex">
                                    <div>{t('payslip.paidWorkingDayLabel')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{Number(payslip?.paid_working_days!) + Number(payslip?.paid_leave!) + Number(payslip?.annual_leave!)} / {payslip?.total_working_days!}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.actualSalary')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.salary! * (Number(payslip?.paid_working_days!) + Number(payslip?.paid_leave!) + Number(payslip?.annual_leave!)) / Number(payslip?.total_working_days!))}</h4>
                                    </div>
                                </div>
                            </div>
                            <div><hr/></div>
                            <div className="p-20">
                                <div className="d-flex">
                                    <div className="align-self-center text-bold">{t('payslip.deductions')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4 className="text-bold-orange">{!showMoney ? "******" : this.CurrencyFormat(Number(payslip?.amercement!) + Number(payslip?.others_deduction!) + Number(payslip?.social_insurance!) + Number(payslip?.health_insurance!) + Number(payslip?.unemployment_insurance!) + Number(payslip?.personal_tax!))}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.socialInsurance')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.social_insurance!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.healthInsurance')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.health_insurance!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.unemploymentInsurance')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.unemployment_insurance!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="align-self-center">{t('payslip.personalIncomeTax')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.personal_tax)}</h4>
                                    </div>
                                </div>
                                {this.ShowPersonalTaxInfo()}
                                {this.ShowPersonalTaxBreakdown()}
                                <div className="d-flex">
                                    <div>{t('payslip.amercement')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.amercement!)}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="align-self-center">{t('payslip.otherDeduction')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(payslip?.others_deduction!)}</h4>
                                    </div>
                                </div>
                                {this.ShowAllOthersDeductions()}
                            </div>
                            <div><hr/></div>
                            <div className="p-20">
                                <div className="d-flex">
                                    <div className="align-self-center text-bold">{t('payslip.netIncome')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4 className="text-bold-green">{!showMoney ? "******" : this.CurrencyFormat(Number(payslip?.earnings!) - Number(payslip?.amercement!) - Number(payslip?.others_deduction!) - (Number(payslip?.social_insurance!) + Number(payslip?.health_insurance!) + Number(payslip?.unemployment_insurance!) + Number(payslip?.personal_tax!)))}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.payableIncome')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(Number(payslip?.payable_income!))}</h4>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div>{t('payslip.bonus')}</div>
                                    <div className="ml-auto align-self-center">
                                        <h4>{!showMoney ? "******" : this.CurrencyFormat(Number(payslip?.bonus!) - Number(payslip?.others_deduction!))}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-xlg-4 col-md-4">
                        {payslip?.installments != null && payslip?.installments!.length > 0 &&
                            <div className="card">
                                <div className="table-responsive">
                                    <table className="table m-b-0 toggle-arrow-tiny color-table muted-table">
                                        <thead>
                                        <tr>
                                            <th className="footable-visible footable-sortable"> {t('installment.title')}</th>
                                            <th className="footable-visible footable-sortable"> {t('installment.amount')}</th>
                                            <th className="footable-visible footable-sortable"> {t('installment.remaining')}</th>
                                            <th className="footable-visible footable-sortable"> {t('installment.start')}</th>
                                            <th className="footable-visible footable-sortable"> {t('installment.end')}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.ShowInstallmentTable()}
                                        <tr key="-1">
                                            <td>
                                                <div className="align-self-center text-bold">{t('installment.thisMonth')}</div>
                                            </td>
                                            <td colSpan={4}>{!showMoney ? "******" : this.CurrencyFormat(Number(this.GetInstallmentThisMonth()))}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>}

                        {/*OT Request*/}
                        <div className="card">
                            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false}
                                            newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover/>
                            <div className="card-header text-center">
                                <div className="row">
                                    <div className="col-md-5 col-8 align-self-center">
                                        <div className="d-flex flex-wrap">
                                            <div className="m-r-20 align-self-center">
                                                <img src="assets/images/clockin.png" alt="assets/images/clockin.png" width="25"/>
                                            </div>
                                            <h4 className="text-center m-t-10">{t('overtime.cardTitle')}</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-4 align-self-center">
                                        {this.props.queryUser?.email == currentUser.email &&
                                            <button data-toggle="modal" data-target="#request-leave-modal"
                                                    className="waves-effect waves-dark btn btn-success btn-md btn-rounded pull-right">
                                                {t('overtime.create')}
                                            </button>}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div style={{maxHeight: '350px', overflow: 'auto', paddingTop: '20px'}}>
                                    {this.ShowOTRequests()}
                                </div>

                                {/* Create OT modal */}
                                <div id="request-leave-modal" className="modal fade" role="dialog"
                                     aria-labelledby="requestLeaveModal" aria-hidden="true">
                                    <form className="form-horizontal form-material" onSubmit={this.handleSubmit}>
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h4 className="modal-title">{t('overtime.createRequest')}</h4>
                                                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="form-group">
                                                        <label className="col-md-12">{t('overtime.date')}</label>
                                                        <div className="col-md-12 input-group">
                                                            <div className="input-group-addon"><i className="ti-time"></i></div>
                                                            <input type="date" value={newOTRequest.date}
                                                                   onChange={this.handleChangeDate}
                                                                   className="form-control form-control-line" name="start" id="start"/>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-md-12">{t('overtime.otHour')}</label>
                                                        <div className="col-md-3 input-group">
                                                            <select className="form-control form-control-line" name="ot_hour" id="ot_hour"
                                                                    onChange={this.handleChangeOTTime}>
                                                                {[1,2,3,4,5,6,7,8,9,10,11,12].map(h => (
                                                                    <option key={h} value={h} selected={newOTRequest.ot_hour == h}>{h}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-md-12">{t('overtime.tasks')}</label>
                                                        <div className="col-md-12 input-group">
                                                            <div className="input-group-addon"><i className="ti-pencil-alt"></i></div>
                                                            <textarea rows={5} cols={80} value={newOTRequest.reason}
                                                                      onChange={this.handleChangeReason}
                                                                      className="form-control form-control-line" name="reason" id="reason"/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="submit" className="btn btn-danger waves-effect waves-light">
                                                        {t('overtime.request')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                {/* Update OT modal */}
                                <div id="update-request-leave-modal" className="modal fade" role="dialog"
                                     aria-labelledby="updateLeaveModal" aria-hidden="true">
                                    <form className="form-horizontal form-material" onSubmit={this.handleUpdate}>
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h4 className="modal-title">{t('overtime.updateRequest')}</h4>
                                                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="form-group">
                                                        <label className="col-md-12">{t('overtime.date')}</label>
                                                        <div className="col-md-12 input-group">
                                                            <div className="input-group-addon"><i className="ti-time"></i></div>
                                                            <input type="date" value={newOTRequest.date}
                                                                   onChange={this.handleChangeDate}
                                                                   className="form-control form-control-line" name="start"
                                                                   disabled={newOTRequest.approve != -1} id="start"/>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-md-12">{t('overtime.otHour')}</label>
                                                        <div className="col-md-3 input-group">
                                                            <select className="form-control form-control-line" name="ot_hour" id="ot_hour"
                                                                    disabled={newOTRequest.approve != -1}
                                                                    onChange={this.handleChangeOTTime}>
                                                                {[1,2,3,4,5,6,7,8,9,10,11,12].map(h => (
                                                                    <option key={h} value={h} selected={newOTRequest.ot_hour == h}>{h}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-md-12">{t('overtime.tasks')}</label>
                                                        <div className="col-md-12 input-group">
                                                            <div className="input-group-addon"><i className="ti-pencil-alt"></i></div>
                                                            <textarea rows={5} cols={80} value={newOTRequest.reason}
                                                                      onChange={this.handleChangeReason}
                                                                      disabled={newOTRequest.approve != -1}
                                                                      className="form-control form-control-line" name="reason" id="reason"/>
                                                        </div>
                                                    </div>
                                                </div>
                                                {newOTRequest.approve == -1 &&
                                                    <div className="modal-footer">
                                                        <button type="submit" className="btn btn-info waves-effect waves-light">
                                                            {t('overtime.update')}
                                                        </button>
                                                    </div>}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="p-20">
                                <div className="d-flex">
                                    <div>{t('bank.bankName')}</div>
                                    <div className="ml-auto align-self-center"><h4>{payslip?.user?.bank_name!}</h4></div>
                                </div>
                                <div className="d-flex">
                                    <div className="align-self-center">{t('bank.bankAccount')}</div>
                                    <div className="ml-auto align-self-center"><h4>{payslip?.user?.bank_account!}</h4></div>
                                </div>
                                <div className="d-flex">
                                    <div className="m-t-10 text-center">
                                        <a href={"https://img.vietqr.io/image/" + payslip?.user?.bank_name + "-" + payslip?.user?.bank_account + "-print.png?accountName=" + payslip?.user?.name}
                                           target="_blank">
                                            <img width="150" height="150"
                                                 src={"https://img.vietqr.io/image/" + payslip?.user?.bank_name + "-" + payslip?.user?.bank_account + "-qr_only.png"}
                                                 alt="qr_code"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

                <div className="col-lg-12 col-xlg-12 col-md-12">
                    <div className="card">
                        <div className="table-responsive">
                            <table className="table m-b-0 toggle-arrow-tiny color-table muted-table">
                                <thead>{this.ShowPayrollHistoryHeader()}</thead>
                                <tbody>{this.ShowPayrollHistoryTable()}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

